import React from 'react';
import Footer from './Footer';
import LogoIcon from '../../svg/LogoIcon';
import { Helmet } from 'react-helmet';

const ContactLayout = ({ children }) => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Consult FGC | Contact Us</title>
        <meta
          name="description"
          content="Consult FGC is a boutique digital marketing, SEO, web design, & web development company. We offer an experienced but personal touch to help meet your digital branding needs & grow your business."
        />
        <link
          rel="icon"
          href="https://consultfgc.netlify.app/static/ConsultFGC_Logo_footer-8b0c6cdcc10d6cc56b61a7b78ed851b7.png"
        />
      </Helmet>

      <div className="flex w-64 mx-auto mt-10 pb-8 border-b">
        <LogoIcon />
      </div>
      <main className="text-gray-900">{children}</main>
      <Footer />
    </>
  );
};

export default ContactLayout;
